<template>
	<div class="page2warp">
		<div class="detail-newscontent" v-if="contentObj">
			<div v-html="contentObj" class="img">
			</div>
		</div>
		<div v-else>
			<div class="emptyBox" style="paddingTop:20px">
				<img src="@/assets/imgs/branchempty.jpg" />
			</div>
		</div>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			pageSize: 100,
			contentObj: null
		}
	},
	mounted() {
		this.getNewsData()
	},
	methods: {
		async getNewsData() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				pressSuperClass: 91,
			};
			let data = await httpService.getHeadList(params);
			if (data.code == 200) {
				if (data.result.list.length != 0) {
					this.contentObj = data.result.list[0]
				}
			}
		},
	}
}
</script>
<style lang="less" scoped>
.page2warp {
	width: 1200px;
	// margin: 0 auto;
	min-height: 600px;
	// padding: 20px 200px;
	.detail-newscontent {
		width: 1200px;
		padding:60px 0 20px 0 ;
		/deep/img{
			width: 1200px;
		}
		.img{
			width: 1200px;
		}
		img{
			width: 1200px;
		}
		
	}
	.leaderBox {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		.leadItem {
			width: 385px;
			height: 168px;
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
			box-sizing: border-box;
			border-radius: 8px;
			padding: 16px 20px 0 20px;
			margin: 30px 38px 0 0;
			&:nth-child(3n) {
				margin-right: 0;
			}

			.name {
				font-size: 18px;
				font-weight: bold;
				line-height: 30px;
				color: #448df7;
				margin-bottom: 10px;
				.position {
					font-size: 16px;
					line-height: 30px;
					color: #333333;
					margin-left: 6px;
				}
			}
			.workbox {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
			}
		}
	}
	.emptyBox {
		img {
			width: 198px;
			height: 200px;
		}
	}
}
</style>


